<template>
  <div>
      <b-container fluid class="px-0">
          <b-card id="card-principal" class="mb-0 pb-0">
              <template #header>
                  <div class="flex-grow-1">
                      <i class="fas fa-table"></i>
                      <strong>{{$lang.Menu.Items.PCI.PDRRoleRationg}}</strong>
                  </div>
                  <div class="card-actions">
                    <b-link href="#" class="bt-link" v-b-tooltip.hover :title="'Adicionar Relatório'" @click="showReportModal">
                      <i class="fa fa-plus" style="font-size:15px;"></i>
                    </b-link>
                  </div>
              </template>
              <!--grid of reports-->
              <b-row>
                  <ag-grid-vue style="width: 100%; height:40vh" id="obras-grid"
                      class="ag-theme-alpine"
                      :rowMultiSelectWithClick="false"
                      rowSelection="single"
                      :getLocaleText="localeTextFunc"
                      :gridOptions="reportGridOptions"
                      :columnTypes="columnTypes"
                      :columnDefs="reportColumnDefs"
                      :defaultColDef="defaultColumnDef"
                      :rowData="reportRowData"
                      :suppressColumnVirtualisation=true
                      @rowSelected="selectReport"
                      @gridReady="onGridReportReady"
                      >
                  </ag-grid-vue>
              </b-row>
              <div class="align-right">
                <div style="display:inline-flex">
                  <div class="bt-link" @click="printAnaliticReport">
                    <i class="fas fa-print"></i>
                    <strong>Analítico</strong>
                  </div>
                  &nbsp;|&nbsp;
                  <div class="bt-link" @click="printGraphicReport">
                    <i class="fas fa-print"></i>
                    <strong>Relatório</strong>
                  </div>
                </div>
              </div>
              <!--tabs section-->
              <b-row>
                  <div class="tab" pills card>
                    <ag-grid-vue style="width: 100%; height:20vh" id="obras-grid"
                        class="ag-theme-alpine"
                        :rowMultiSelectWithClick="false"
                        rowSelection="single"
                        :getLocaleText="localeTextFunc"
                        :gridOptions="workGridOptions"
                        :columnTypes="columnTypes"
                        :columnDefs="workColumnDefs"
                        :defaultColDef="defaultColumnDef"
                        :rowData="workRowData"
                        :suppressColumnVirtualisation=true
                        @rowSelected="SelectCoordinator"
                        @gridReady="onGridWorkReady"
                        >
                    </ag-grid-vue>
                    </div>
              </b-row>
          </b-card>
      </b-container>

      <!-- Meta Itens -->
        <b-modal
            v-model="showReportFom"
            title="Cadastrar Novo Relatório"
            size="xl"
            :hide-footer="true"
            centered>
          <div class="d-flex flex-column justify-content-start">
            <b-row><b-col><b>Período de apuração</b></b-col></b-row>
            <b-row>
              <b-col class="col-2">Início</b-col>
              <b-col class="col-2">Término</b-col>
              <b-col></b-col>
            </b-row>
            <b-row>
              <b-col class="col-2">
                <b-form-input type="date" v-model="reportForm.inicio" :value="reportForm.inicio" />
              </b-col>
              <b-col class="col-2">
                <b-form-input type="date" v-model="reportForm.termino" :value="reportForm.termino" />
              </b-col>
              <b-col></b-col>
            </b-row>
            <b-row><b-col><hr/></b-col></b-row>
            <b-row>
              <b-col>Descrição</b-col>
              <b-col>Função</b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-input type="text"
                      v-model="reportForm.descricao"
                      :value="reportForm.descricao" />
              </b-col>
              <b-col>
                <b-form-select id="select-available"
                            class="select-contracts form-control"
                            :options="availableFunction.options"
                            v-model="reportForm.funcaoobraid">
                        </b-form-select>
              </b-col>
            </b-row>
            <b-row>
                <b-col>Não Conformidade</b-col>
                <b-col>Causas</b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-textarea rows="3"
                      v-model="reportForm.naoconformidade"
                      :value="reportForm.naoconformidade" />
              </b-col>
              <b-col>
                <b-form-textarea rows="3"
                      v-model="reportForm.causas"
                      :value="reportForm.causas" />
              </b-col>
            </b-row>
            <b-row>
                <b-col>Ações Preventivas/Corretivas</b-col>
                <b-col>Responsáveis</b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-textarea rows="3"
                      v-model="reportForm.acoespreventivacorretiva"
                      :value="reportForm.acoespreventivacorretiva" />
              </b-col>
              <b-col>
                <b-form-textarea rows="3"
                      v-model="reportForm.responsaveis"
                      :value="reportForm.responsaveis" />
              </b-col>
            </b-row>
            <b-row>
                <b-col>Observação</b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-textarea rows="3"
                      v-model="reportForm.observacao"
                      :value="reportForm.observacao" />
              </b-col>
            </b-row>
            <b-row>
                <b-col class="align-right">
                    <hr />
                    <button type="button" class="btn btn-third btn-sm" v-on:click="sendReportForm" v-b-tooltip.hover>
                        <i class="fa fa-check"></i>&nbsp;&nbsp;Adicionar
                    </button>
                </b-col>
            </b-row>
          </div>
      </b-modal>

  </div>
</template>

<script>
export default {
  name: 'ReportWorkPosition'
}
</script>
<script>
import ReportWorkPosition from './reportWorkPosition.js'
export default ReportWorkPosition
</script>

<style scoped>
    .tab {
        width: 100%;
        margin: 0px 5px 0px 5px;
    }
    .align-right {
        text-align: right;
    }
    .bt-link {
      cursor: pointer;
    }
    .bt-link:hover {
      color: #007bff;
      transform: .3s;
    }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/reportWorkPosition/reportWorkPosition.vue